import useTableRequest from "../../hooks/useTableRequest";
import TableState from "../../components/common/table/TableState";
import { useCallback, useEffect, useState } from "react";
import Title from "../../components/common/title/Title";
import ExportExcel from "../../components/common/export-exel/ExportExel";
import { digitsThree } from "../../utils/price";
import DateOnlyInput from "../../components/common/inputs/DateOnlyInput";

export default function ProductSalesSummary() {
  const [filters, setFilters] = useState({ from: "", to: "" });
  const [rows, setRows] = useState([]);
  const { load: request, loading, error, retry } = useTableRequest();

  const load = useCallback(async (params) => {
    return request({ path: "admin/reports/productSalesSummary", params }, (response) => {
      setRows(Array.isArray(response?.data?.result) ? response.data.result : []);
    });
  }, [request]);
  useEffect(() => { load({}); }, [load]);

  const exportRows = rows.map((row) => ({
    "شناسه کالا": row.productSku,
    "نام محصول": row.productName,
    "تعداد فروش": row.salesCount,
    "قیمت فروش": row.price,
    "قیمت خرید": row.buyPrice,
    "تاریخ ایجاد": row.createdAt ? new Date(row.createdAt).toLocaleDateString("fa-IR") : "",
  }));

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Title title="خلاصه فروش هر کالا" />
        <ExportExcel jsonData={exportRows} disabled={loading || error} />
      </div>
      <p className="text-sm text-slate-600 dark:text-slate-300">
        تعداد فروش هر SKU فعال را در بازهٔ تاریخ پرداخت نشان می‌دهد. کالاهای داخل پک نیز به تفکیک کالا محاسبه می‌شوند.
      </p>
      <form onSubmit={(event) => { event.preventDefault(); load(filters); }} className="flex flex-wrap items-end gap-3">
        <DateOnlyInput name="product-sales-from" label="از تاریخ پرداخت" value={filters.from} onChange={(from) => setFilters((previous) => ({ ...previous, from }))} />
        <DateOnlyInput name="product-sales-to" label="تا تاریخ پرداخت" value={filters.to} onChange={(to) => setFilters((previous) => ({ ...previous, to }))} />
        <button type="submit" disabled={loading} className="rounded-lg bg-blue-700 text-white px-4 py-2 disabled:opacity-50">نمایش گزارش</button>
      </form>
      {(loading || error) && <TableState loading={loading} error={error} onRetry={retry} />}
      <div className="overflow-x-auto" hidden={loading || error}>
        <table className="w-full text-sm text-right dark:text-white">
          <thead><tr className="bg-gray-100 dark:bg-gray-800"><th className="p-2">SKU</th><th className="p-2">نام محصول</th><th className="p-2">تعداد فروش</th><th className="p-2">قیمت فروش</th><th className="p-2">قیمت خرید</th></tr></thead>
          <tbody>{rows.map((row, index) => <tr key={`${row.productSku}-${index}`} className="border-b"><td className="p-2" dir="ltr">{row.productSku}</td><td className="p-2">{row.productName}</td><td className="p-2">{digitsThree(row.salesCount)}</td><td className="p-2">{digitsThree(row.price)}</td><td className="p-2">{digitsThree(row.buyPrice)}</td></tr>)}</tbody>
        </table>
        {!loading && !rows.length && !error && <p className="p-4 text-sm text-gray-500">داده‌ای برای نمایش وجود ندارد.</p>}
      </div>
    </div>
  );
}
